module.exports = __webpack_public_path__ + "img/image_input_icon2.3200d2a9.svg";